import React from 'react';
import { CheckboxInput } from 'ui-builder';
import { FileType } from 'nekst-api';
import { FileUploaderInput } from 'features/nekst-widgets';

export default function ContractExampleFileUploader() {

  return (
    <>
      <FileUploaderInput
        fileType={FileType.PROJECT_DOCUMENT}
        fileDataSource="_contractDocumentExampleFile"
        source="contractDocumentExampleFileId"
        label="Contract Document Example File"
        hint="A contract document example is utilized for training AI systems to comprehend the content and structure of contractual agreements."
      />
      <FileUploaderInput
        fileType={FileType.PROJECT_DOCUMENT}
        fileDataSource="_contractDocumentValidationFile"
        source="contractDocumentValidationFileId"
        label="Contract Document Validation File"
        hint="A contract document validation file is utilized for training AI systems to validate the AI training configuration."
      />
      <CheckboxInput
        source="applyOcrProcessing"
        label="Force applying of OCR Processing"
        hint="Use this option to force the application of OCR processing on the uploaded document.
         Otherwise, the system will automatically determine if OCR processing is required."
      />
    </>
  );
}
